import { render, staticRenderFns } from "./Author.vue?vue&type=template&id=fb94e2d0&scoped=true&"
import script from "./Author.vue?vue&type=script&lang=ts&"
export * from "./Author.vue?vue&type=script&lang=ts&"
import style0 from "./Author.vue?vue&type=style&index=0&id=fb94e2d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb94e2d0",
  null
  
)

export default component.exports